import { useMediaQuery } from "@react-hook/media-query";

export const useIsDesktop = () => {
  const isDesktop = useMediaQuery("only screen and (min-width: 830px)");
  return isDesktop;
};
